import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, CreditCard, ShieldCheck } from 'lucide-react';

const BookingPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <h1 className="font-serif-display text-4xl md:text-5xl text-slate-900 mb-6 text-center">Booking & Cancellation Policy</h1>
          <p className="text-slate-500 text-center max-w-2xl mx-auto">
            Clear guidelines for a smooth experience. Please read our policies carefully before booking.
          </p>
        </motion.div>

        <div className="grid gap-8">
          <section className="p-8 rounded-[2rem] bg-slate-50 border border-slate-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                <CreditCard className="w-5 h-5" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Payments & Deposits</h2>
            </div>
            <ul className="space-y-4 text-slate-600 list-disc pl-5">
              <li>A minimum token amount of 20-50% is required to confirm your booking slot.</li>
              <li>The remaining balance must be paid upon completion of the decoration.</li>
              <li>We accept payments via UPI, Credit/Debit cards, and Bank Transfers.</li>
            </ul>
          </section>

          <section className="p-8 rounded-[2rem] bg-slate-50 border border-slate-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center text-orange-600">
                <AlertCircle className="w-5 h-5" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Cancellation & Rescheduling</h2>
            </div>
            <ul className="space-y-4 text-slate-600 list-disc pl-5">
              <li>Cancellations made 48 hours before the event will receive a 50% refund of the deposit.</li>
              <li>Cancellations made less than 24 hours before the event are non-refundable.</li>
              <li>Rescheduling is allowed once for free if requested 24 hours in advance, subject to slot availability.</li>
            </ul>
          </section>

          <section className="p-8 rounded-[2rem] bg-slate-50 border border-slate-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center text-blue-600">
                <Clock className="w-5 h-5" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Setup & Timings</h2>
            </div>
            <ul className="space-y-4 text-slate-600 list-disc pl-5">
              <li>Our team requires at least 2-3 hours for a standard setup. Please ensure the venue is available.</li>
              <li>We are not responsible for delays caused by lack of electricity, permission issues, or venue restrictions.</li>
              <li>Any damage to venue property during setup must be reported immediately.</li>
            </ul>
          </section>

          <section className="p-8 rounded-[2rem] bg-green-50 border border-green-100">
            <div className="flex items-center gap-4 mb-4 text-green-700">
              <ShieldCheck className="w-5 h-5" />
              <h2 className="font-bold">Trust & Safety</h2>
            </div>
            <p className="text-green-800/80 text-sm">
              We value your celebrations. In case of any unforeseen circumstances from our side, we guarantee a full refund or a premium upgrade to your package.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BookingPolicyPage;
